import type { EntityConfiguration } from '@technocom/data/core';
import { DictionaryDTO, DictionaryRef } from '@app/shared/models/dictionaries/dictionary-ref';

export enum PurposeType {
  // туризм
  Tourism = 1,
  // работа
  Job,
  // работа (проживание) в качестве высококвалифицированного специалиста
  WorkSpecialist,
  // работа (проживание) в качестве члена семьи высококвалифицированного специалиста
  WorkFamilySpecialist,
  // учеба
  Studies,
  // переселение в качестве участника государственной программы переселения соотечественников
  Resettlement,
  // переселение в качестве члена семьи участника государственной программы переселения соотечественников
  ResettlementFamily,
  // частная
  Private,
}

/**
 * Цели визита
 */
export class Purpose extends DictionaryRef {
  static readonly options: EntityConfiguration = DictionaryRef.extendOptions({
    namespace: 'purpose',
    title: 'Цели визита',
    serverUrl: '/dictionary/purpose',
  });
}
